var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowBottom48Line = function SvgIconArrowBottom48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.03 29.372a2.9 2.9 0 0 1-2.1-.91l-7.13-7.52 2.47-2.34 6.77 7.14 6.76-7.14 2.47 2.34-7.13 7.52a2.899 2.899 0 0 1-2.11.91Z",
    fill: "current"
  })));
};
export default SvgIconArrowBottom48Line;